<template>
  <b-modal
    ref="resetServer"
    centered
    size="lg"
    title="Confirm server reset"
    header-text-variant="danger"
    hide-header
    footer-bg-variant=""
    scrollable
    @hidden="
      unselectServer(),
      resetCheckbox()
    ">

    <b-alert
      variant="light-danger"
      show
      class="mb-8">
      <p class="font-size-lg mb-4">
        When confirming data clearance for this server, you're ensuring it will be a fresh, clean server. All user data associated with this server will be deleted, including:
      </p>
      <ul class="font-size-lg mb-4">
        <li>all VPN server accounts,</li>
        <li>all online users,</li>
        <li>all installed VPN servers.</li>
      </ul>
      <p class="font-size-lg">
        After the cleanup, you will need to reinstall the VPN server.
      </p>
      <b-form-checkbox
        required
        id="userAgreed"
        v-model="userAgreed"
        name="userAgreed"
        :state="userAgreed === false ? false : null"
        class="mb-0 font-weight-500">
        <span class="font-weight-bold font-size-lg line-height-sm">
          I understand what I am doing and confirm that this will be a clean server.
        </span>
      </b-form-checkbox>
    </b-alert>

    <div class="font-weight-bold mb-2">Server Details</div>
    <b-list-group
      v-if="selectedServerId !== null"
      class="mb-0">
      <b-list-group-item class="d-flex align-items-center">
        Name
        <span class="ml-auto">{{ selectedServer.name }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Location
        <span class="ml-auto">
          <div class="d-flex align-items-center">
            <img
              :src="countryFlag(selectedServer.country)"
              :alt="selectedServer.country"
              class="w-20px mr-2 no-select rounded-sm bg-light border border-light rounded-sm" />
            <span
              class="d-inline-block mr-1 text-truncate"
              style="max-width: 180px;">{{ countryName(selectedServer.country) }}, {{ selectedServer.location }}</span>
          </div>
        </span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        IP
        <span class="ml-auto">{{ selectedServer.ip }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Status
        <span class="ml-auto font-size-xs">
          <b-badge :variant="serverStatusBadge(selectedServer).variant">
            <i :class="`fa fa-sm fa-${serverStatusBadge(selectedServer).icon} text-white`"></i>
            {{ serverStatusBadge(selectedServer).text }}
          </b-badge>
        </span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Client Version
        <span class="ml-auto">
          <span v-if="selectedServer.client_version">
            <span class="font-size-xs">v</span>
            <span>{{ selectedServer.client_version }}</span>
          </span>
          <i
            v-else
            class="fa fa-minus fa-xs opacity-50" />
        </span>
      </b-list-group-item>
    </b-list-group>

    

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('resetServer')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :class="{ 'disabled' : !userAgreed }"
          @click="handleReset()">
          Reset Server
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { RESET_SERVER, UNSELECT_SERVER } from '@/core/services/store/servers.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'

export default {
  name: 'ModalShutdownServer',
  data() {
    return {
      showModal,
      hideModal,

      userAgreed: undefined,
    }
  },
  computed: {
    ...mapGetters([
      'countryFlag',
      'countryName',

      'selectedServer',
      'selectedServerId',
      'serverStatusBadge',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectServer() {
      this.$store.commit(UNSELECT_SERVER)
    },

    handleReset() {
      if (this.userAgreed) {
        this.$store.dispatch(RESET_SERVER, this.selectedServer)
        this.hideModal('resetServer')
      } else {
        this.userAgreed = false
      }
    },

    resetCheckbox() {
      this.userAgreed = undefined
    },

    resetServer() {
      this.$store.dispatch(RESET_SERVER)
    },
  }
}
</script>
